/**
 * Resolve API-hosted media paths (e.g. /uploads/avatars/…) to absolute URLs.
 */
export function getApiOrigin() {
    const apiUrl = process.env.REACT_APP_API_URL
        || (typeof window !== 'undefined' && /localhost|127\.0\.0\.1/.test(window.location.hostname)
            ? 'http://localhost:5000/api'
            : 'https://api.tauris.io/api');
    return String(apiUrl).replace(/\/api\/?$/, '');
}

export function resolveMediaUrl(pathOrUrl) {
    if (!pathOrUrl) return '';
    const value = String(pathOrUrl).trim();
    if (!value) return '';
    if (/^(https?:|data:|blob:)/i.test(value)) return value;
    const origin = getApiOrigin();
    return `${origin}${value.startsWith('/') ? value : `/${value}`}`;
}
